import { IDB_pointsAwardedEvents } from '../IDB/IDB.dexie'
import { User_totalPointsUpdate } from '../User/User.update'
import * as sentry from '../../src/utils/sentry'
import { Serv_client } from '../Serv/Serv.client'

export async function Gami_sync() {
    try {
        // Get events that need to be synced up
        const pointsAwardedEvents = await IDB_pointsAwardedEvents().toArray()

        // Send up to the server and get the new user total
        const { totalPoints } = await Serv_client.awardPoints(pointsAwardedEvents)

        // Update the user total with the value from the server (might have been reset to 0)
        await User_totalPointsUpdate(totalPoints)

        // Delete the event now they've been uploaded to the server
        await IDB_pointsAwardedEvents().bulkDelete(pointsAwardedEvents.map((e) => e.time))
    } catch (error) {
        sentry.err(error, {})
    }
}
